import { useState } from "react";

import {
  Button,
  PageLayout,
  ResponsiveGridLayoutProps,
  getLayoutsFromLocalStorage,
} from "@ezmid/components-library";
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

import { DashboardPageContent } from "../organisms/DashboardPageContent";
import { defaultLayouts } from "../organisms/layouts";

export function DashboardPage() {
  const { t } = useTranslation();
  const [layouts, setLayouts] = useState<ResponsiveGridLayoutProps>(
    JSON.parse(
      JSON.stringify(getLayoutsFromLocalStorage("layouts") || defaultLayouts)
    )
  );

  const handleResetLayout = () => {
    setLayouts(defaultLayouts);
  };

  return (
    <PageLayout
      title={t("dashboard.page.title")}
      navigation={
        <div className="mr-2">
          <Button
            onClick={handleResetLayout}
            leftIcon={<FontAwesomeIcon icon={faSyncAlt} size="1x" />}
          >
            {t("app.layout.layoutReset")}
          </Button>
        </div>
      }
    >
      <DashboardPageContent layouts={layouts} setLayouts={setLayouts} />
    </PageLayout>
  );
}
